
import { mapGetters } from "vuex";
// import UiBreadcrumbs from "@/components/UI/UiBreadcrumbs.vue";
import BlocksContainer from "~/components/blocks/BlocksContainer";
import CatalogList from "@/components/common/CatalogList.vue";
import { metaGenerator, getPageFromQuery } from "@/utils";
import googleAnalyticsEvents from "~/mixins/googleAnalyticsEvents";
import facebookPixelEvents from "~/mixins/facebookPixelEvents";
import useEvents from "~/mixins/useEvents";

export default {
  components: {
    BlocksContainer,
    // UiBreadcrumbs,
    // CatalogList,
  },
  mixins: [googleAnalyticsEvents, facebookPixelEvents, useEvents],

  async asyncData({ error, $api }) {
    const getPage = async () => {
      try {
        const { data } = await $api.pages.getPage("catalog");
        return data.data;
      } catch (err) {
        console.log("err - ", err?.response?.data?.errors);
        error({ statusCode: err.response.status });
      }
    };
    return {
      pageData: await getPage(),
    };
  },
  head() {
    const i18nHead = this.$nuxtI18nHead({
      addSeoAttributes: {
        // TODO remove after reindex
        canonicalQueries: getPageFromQuery(this.$route.query.page) === 1 ? false : ["page"],
      },
    });

    const currentPage = getPageFromQuery(this.$route.query.page);
    const pageNumberTitlePart = currentPage > 1 ? ` | ${this.$t("page")} ${currentPage}` : "";
    const metaTitle = (this.pageData?.mixedTranslation?.meta_title || this.pageData?.mixedTranslation?.title || "") + pageNumberTitlePart;
    const titleTemplate = `%s | ${this.getCompanyName}`;
    return {
      meta: [
        ...metaGenerator({
          title: metaTitle,
          description: (this.pageData?.mixedTranslation?.meta_description || "") + pageNumberTitlePart,
          image:
            this.pageData?.medias?.find((el) => el.position === "open-graph")
              ?.file?.url || "",
          url:
            this.pageData?.mixedTranslation?.meta_url ||
            process.env.DOMAIN + this.$route.fullPath,
          company_name: this.getCompanyName,
          titleTemplate,
        }),
        ...i18nHead.meta,
      ],
      htmlAttrs: i18nHead.htmlAttrs,
      link: i18nHead.link,
      title: metaTitle,
      titleTemplate,
    };
  },
  computed: {
    ...mapGetters({
      getCompanyName: "general/getCompanyName",
    }),
    canSendGoogleAnalyticsStatistic() {
      return this.integrationCallbackStatuses.TYPE_GOOGLE_ANALYTICS && this.$route.query.search;
    },
    canSendFBStatistic() {
      return this.integrationCallbackStatuses.TYPE_FACEBOOK_PIXEL && this.$route.query.search;
    },
  },
  watch: {
    canSendGoogleAnalyticsStatistic: {
      handler(val) {
        if (val) {
          this.gaViewSearchResultEvent(this.$route.query.search);
        }
      },
      immediate: true,
    },
    canSendFBStatistic: {
      handler(val) {
        if (val) {
          this.fbViewSearchResultEvent(this.$route.query.search);
        }
      },
      immediate: true,
    },
  },
  created() {
    this.setBreadcrumbs();
  },
  mounted () {
    this.visitEvent(this.pageData.is_plp);
  },
  methods: {
    setBreadcrumbs() {
      this.$store.commit("general/SET_BREADCRUMBS", [
        {
          text: this.$t("home"),
          disabled: false,
          href: this.localePath("/"),
        },
        {
          text: this.$t("catalog"),
          disabled: true,
          href: this.$route.path,
        },
      ]);
    },
  },
};
